import { useState } from "react";
import {
    Box,
    Paper,
    Typography,
    Container,
    CircularProgress,
    TextField,
    Modal,
    Button,
    Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,

} from "@mui/material";
import { FormatRut } from "../../../Components/FuncionesGenerales/Rut";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Loading } from "../../../Utils/Loading";
import Logocolor from "../../../Image/Logo.png";
import { modalStyle, buttonGuardar, buttonCancelar, Titulo, TituloPrincipal, Texto, Input, TituloColor} from "../../../Layouts/CustomStyles";
import { useGetContacto } from "../../../Hook/RME/contacto";
import { useProveedores } from "../../../Services/Proveedores";
import { useContacto } from "../../../Services/Contacto";
import { DiseñoDataGrid } from "../../../Components/FuncionesGenerales/DataGrid";
import { FaTrashCan } from "react-icons/fa6";
import { useProveedoresRME } from "../../../Hook/RME/Proveedor";


export const IndexPorveedor = () => {
    const { Contacto, errorContacto, loadingContacto, refetchContacto } = useGetContacto();
    const { eliminarContacto,  editarContacto } = useContacto();
    const {  editarProveedores, eliminarProveedores} = useProveedores();
    const { proveedores, loadingProveedores, errorProveedores, refetchProveedores} = useProveedoresRME();
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [itemToEdit, setItemToEdit] = useState(null);
    const [formData, setFormData] = useState({});
    /* estados */
    const [openDialog, setOpenDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const isProveedor = !!itemToEdit?.razon_social;
    const columns = [
        { field: "name", headerName: "Nombre", flex: 1 },
        { field: "rut", headerName: "RUT", flex: 1 },
        { field: "email", headerName: "Email", flex: 1 },
        { field: "phone", headerName: "Teléfono", flex: 1 },
        { field: "type", headerName: "Tipo", flex: 1 },

        {
            field: "acciones",
            headerName: "Acciones",
            flex: 1,
            renderCell: (params) => (
                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                        width: 150,
                        alignItems: "center",
                        justifyContent: "center",
                    }}>

                    <Tooltip title="Editar">
                        <button className="edit-button" onClick={() => handleOpenEditDialog(params.row)}
                        >
                            <svg className="edit-svgIcon" viewBox="0 0 512 512">
                                <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                            </svg>
                        </button>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                        <button className="delete-button" onClick={() => handleOpenDeleteDialog(params.row)} >
                            <FaTrashCan className="delete-svgIcon" />
                        </button>
                    </Tooltip>
                </Box>
            )
        }
    ];
    const columnsProveedores = [
  { field: "razon_social", headerName: "Razón Social", flex: 1 },
  { field: "rut_proveedor", headerName: "RUT", flex: 1 },

   {
            field: "acciones",
            headerName: "Acciones",
            flex: 1,
            renderCell: (params) => (
                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                        width: 150,
                        alignItems: "center",
                        justifyContent: "center",
                    }}>

                    <Tooltip title="Editar">
                        <button className="edit-button" onClick={() => handleOpenEditDialog(params.row)}
                        >
                            <svg className="edit-svgIcon" viewBox="0 0 512 512">
                                <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                            </svg>
                        </button>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                        <button className="delete-button" onClick={() => handleOpenDeleteDialog(params.row)} >
                            <FaTrashCan className="delete-svgIcon" />
                        </button>
                    </Tooltip>
                </Box>
            )
        }
];
   
    const handleOpenDeleteDialog = (row) => {
  setItemToDelete(row);
  setOpenDeleteDialog(true);
};
   const handleSave = async () => {
  setLoading(true);
  setEnviandoAlert(true);

  try {
    if (itemToEdit?.razon_social) {
    
      await editarProveedores(itemToEdit.id, formData);
      refetchProveedores();

      setAlertMessage('Se ha editado proveedor correctamente.');
    } else {
     
      await  editarContacto(itemToEdit.id, formData);
      refetchContacto();

      setAlertMessage('Se ha editado contacto correctamente.');
    }

    handleCloseEditDialog();
    setSuccessAlertOpen(true);

  } catch (error) {
    console.error(error);
    setErrorAlertOpen(true);
    setAlertMessage(error?.message || "Ocurrió un error inesperado al editar.");
  } finally {
    setLoading(false);
    setEnviandoAlert(false);
  }
};

  
    const handleOpenEditDialog = (row) => {
  setItemToEdit(row);
  setFormData(row);
  setOpenEditDialog(true);
};

  const handleCloseEditDialog = () => {
  setOpenEditDialog(false);
  setItemToEdit(null);
  setFormData({});
};

const handleConfirmDelete = async () => {
  if (!itemToDelete) return;

  try {
    if (itemToDelete?.razon_social) {
    
      await eliminarProveedores(itemToDelete.id);
      refetchProveedores();
      setAlertMessage("Proveedor eliminado correctamente");
    } else {
    
      await eliminarContacto(itemToDelete.id);
      refetchContacto();
      setAlertMessage("Contacto eliminado correctamente");
    }

    setSuccessAlertOpen(true);
  } catch (error) {
    console.error(error);
    setErrorAlertOpen(true);
    setAlertMessage("Error al eliminar");
  } finally {
    setOpenDeleteDialog(false);
    setItemToDelete(null);
  }
};

   const handleChange = (e) => {
  const { name, value } = e.target;

  // 👉 Si es RUT (contacto o proveedor)
  if (name === "rut" || name === "rut_proveedor") {
    setFormData((prev) => ({
      ...prev,
      [name]: FormatRut(value),
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};
    if (loadingContacto) {
        return <Loading />;
    }

    if (errorContacto) {
        return <Typography color="error">Error al cargar contactos</Typography>;
    }

    if (loadingProveedores) {
  return <Loading />;
}

if (errorProveedores) {
  return <Typography color="error">Error al cargar proveedores</Typography>;
}
    return (
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <Paper
                elevation={3}
                sx={{
                    p: 3,
                    backgroundColor: "#fff",
                    borderRadius: "16px",
                    minHeight: "50vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box display="flex" alignItems="center" gap={2} mb={6}>
                    <img
                        src={Logocolor}
                        alt="Logo Clínica Activa"
                        style={{ width: 55, height: 55, objectFit: "contain" }}
                    />
                    <Typography variant="h5" sx={TituloPrincipal}>
                        Gestión de Contactos Ingresos
                    </Typography>
                </Box>
                <Box sx={{ height: 500, width: "100%" }}>
                    <DataGrid
                        rows={Contacto || []}
                        columns={columns}
                        getRowId={(row) => row.id}
                        pageSize={10}
                        rowsPerPageOptions={[5, 10, 25]}
                        disableSelectionOnClick
                       
                        slots={{ noRowsOverlay: DiseñoDataGrid }}
                        sx={{
                            fontFamily: 'Poppins, sans-serif',
                            '& .MuiDataGrid-columnHeaders': {
                                color: '#113e21ff',
                                fontWeight: 600,
                                textTransform: 'capitalize',
                            },
                            '& .MuiDataGrid-cell': {
                                textTransform: 'capitalize',
                            },
                        }}
                    />
                </Box>
            </Paper>
            <Paper
                elevation={3}
                sx={{
                    mt: 2,
                    p: 3,
                    backgroundColor: "#fff",
                    borderRadius: "16px",
                    minHeight: "50vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box display="flex" alignItems="center" gap={2} mb={6}>
                    <img
                        src={Logocolor}
                        alt="Logo Clínica Activa"
                        style={{ width: 55, height: 55, objectFit: "contain" }}
                    />
                    <Typography variant="h5" sx={TituloPrincipal}>
                        Gestión de Proveedores Egresos
                    </Typography>
                </Box>
                <Box sx={{ height: 500, width: "100%" }}>
                    <DataGrid
                        rows={proveedores || []}
                        columns={columnsProveedores}
                        getRowId={(row) => row.id}
                        pageSize={10}
                        rowsPerPageOptions={[5, 10, 25]}
                        disableSelectionOnClick
                       
                        slots={{ noRowsOverlay: DiseñoDataGrid }}
                        sx={{
                            fontFamily: 'Poppins, sans-serif',
                            '& .MuiDataGrid-columnHeaders': {
                                color: '#113e21ff',
                                fontWeight: 600,
                                textTransform: 'capitalize',
                            },
                            '& .MuiDataGrid-cell': {
                                textTransform: 'capitalize',
                            },
                        }}
                    />
                </Box>
            </Paper>
            <Dialog open={openEditDialog} onClose={handleCloseEditDialog} fullWidth maxWidth="sm">
 <DialogTitle sx={ Titulo}>
  {isProveedor ? "Editar Proveedor" : "Editar Contacto"}
</DialogTitle>

  <DialogContent>

    {/* CONTACTO */}
    {itemToEdit?.name && (
      <>
        <TextField sx={Input} fullWidth margin="dense" label="Nombre" name="name" value={formData.name || ""} onChange={handleChange}/>
        <TextField
  sx={Input}
  fullWidth
  margin="dense"
  label="RUT"
  name="rut"
  value={formData.rut || ""}
  onChange={handleChange}
/>
        <TextField sx={Input} fullWidth margin="dense" label="Email" name="email" value={formData.email || ""} onChange={handleChange}/>
        <TextField sx={Input} fullWidth margin="dense" label="Teléfono" name="phone" value={formData.phone || ""} onChange={handleChange}/>
      </>
    )}

    {/* PROVEEDOR */}
    {itemToEdit?.razon_social && (
      <>
        <TextField  sx={Input} fullWidth margin="dense" label="Razón Social" name="razon_social" value={formData.razon_social || ""} onChange={handleChange}/>
       <TextField
  sx={Input}
  fullWidth
  margin="dense"
  label="RUT"
  name="rut_proveedor"
  value={formData.rut_proveedor || ""}
  onChange={handleChange}
/>
      </>
    )}

  </DialogContent>

  <DialogActions>
    <Button sx={buttonCancelar} onClick={handleCloseEditDialog}>Cancelar</Button>
    <Button sx={buttonGuardar} onClick={handleSave}>
      Guardar
    </Button>
  </DialogActions>
</Dialog>

<Dialog
  open={openDeleteDialog}
  onClose={() => setOpenDeleteDialog(false)}
>
  <DialogTitle sx={Texto}>
    Confirmar eliminación
  </DialogTitle>

  <DialogContent>
    <DialogContentText sx={Texto}>
      {itemToDelete?.razon_social
        ? "¿Seguro que deseas eliminar este proveedor?"
        : "¿Seguro que deseas eliminar este contacto?"}
    </DialogContentText>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenDeleteDialog(false)}>
      Cancelar
    </Button>
    <Button color="error" variant="contained" onClick={handleConfirmDelete}>
      Eliminar
    </Button>
  </DialogActions>
</Dialog>

 <Modal  open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '350px',
            height: 'auto',
            bgcolor: '#ffff',
            boxShadow: 24,
            p: 1,
            borderRadius: '10px',
            '@media (max-width: 500px)': {
              width: '90%',
            },
          }}
        >
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: 'center' }}>
            <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
            <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600', marginTop: "-5px" }}>
              {alertMessage}
            </p>
          </section>
        </Box>
      </Modal>

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '350px',
            height: 'auto',
            bgcolor: '#ffff',
            boxShadow: 24,
            p: 1,
            borderRadius: '10px',
            '@media (max-width: 500px)': {
              width: '90%',
            },
          }}
        >
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: 'center' }}>
            <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
            <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600' }}>
              {alertMessage}
            </p>
          </section>
        </Box>
      </Modal>

      <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '350px',
            height: 'auto',
            bgcolor: '#ffff',
            boxShadow: 24,
            p: 1,
            borderRadius: '10px',
            '@media (max-width: 500px)': {
              width: '90%',
            },
          }}
        >
          <section style={{ textAlign: 'center', padding: '1rem' }}>
            <CircularProgress style={{ color: '#e83b33' }} />
            <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600', marginTop: '20px' }}>
              Procesando solicitud...
            </p>
          </section>
        </Box>
      </Modal>
        </Container>
    )
}
